import moment from "moment";
import { ChantInput, ChantSelect } from "../../../CommonComponents";

const DirectoryGeneral = ({ general, handleOptionChange, handleInputChange }) => {
  const yearOptions = [
    "2025",
    ...Array.from(
      { length: moment().year() - 1949 },
      (_, index) => (1950 + index).toString()
    ).reverse(),
  ].map((year) => ({ value: year, label: year }));

  return (
    <div>
      <h5 className="group-listing-section-title">General</h5>
      <div className="group-listing-fields-grid">
        <ChantSelect
          label="Status with Club"
          value={general.clubStatus}
          onChange={(value) =>
            handleOptionChange({ target: { name: "general.clubStatus", value } })
          }
          placeholder="Select"
          options={["Official", "Unofficial"].map((v) => ({
            value: v,
            label: v,
          }))}
          helpText="Select if club recognizes 'Official' groups"
        />
        <ChantSelect
          label="Group Size"
          value={general.groupSize}
          onChange={(value) =>
            handleOptionChange({ target: { name: "general.groupSize", value } })
          }
          placeholder="Select"
          options={["1-99", "100-249", "250-499", "500-999", "1000+"].map(
            (v) => ({ value: v, label: v })
          )}
        />
        <ChantSelect
          label="Founded"
          value={general.founded}
          onChange={(value) =>
            handleOptionChange({ target: { name: "general.founded", value } })
          }
          placeholder="Select"
          options={yearOptions}
        />
        <ChantInput
          label="Membership Fee"
          name="general.membershipFee"
          placeholder="Example: $25 or Free"
          maxLength={4}
          onChange={handleInputChange}
          value={general.membershipFee}
          helpText="Include the currency symbol if adding a membership fee"
        />
      </div>
    </div>
  );
};

export default DirectoryGeneral;
